"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VARIANTS", {
  enumerable: true,
  get: function get() {
    return _button.VARIANTS;
  }
});
exports.secureExternalLink = exports.isExternalUrl = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("../../styles/button"));
var _index = _interopRequireDefault(require("../../theme/index"));
var _excluded = ["loading", "variant"],
  _excluded2 = ["variant", "loading", "text", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// filtering styling props from being rendered as HTML attributes
// https://github.com/styled-components/styled-components/issues/439
var StyledLink = (0, _styledComponents["default"])(function (_ref) {
  var loading = _ref.loading,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("a", rest);
}).withConfig({
  displayName: "LinkButton__StyledLink",
  componentId: "sc-11hi4j6-0"
})(["", " ", ""], _button["default"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && (0, _styledComponents.css)(["&,&:hover,&:active{color:", ";background-color:#f0f0f5;border-color:#f0f0f5;}"], _index["default"].greyishBrown);
});
var EXTERNAL_URL_REGEX = /^(https?:)\S*$/;
var EXTERNAL_TARGET_DEFAULT = '_blank';
var EXTERNAL_REL_DEFAULT = 'noreferrer noopener';
var isExternalUrl = exports.isExternalUrl = function isExternalUrl(url) {
  return EXTERNAL_URL_REGEX.test(url);
};
var secureExternalLink = exports.secureExternalLink = function secureExternalLink(href) {
  if (!isExternalUrl(href)) {
    return undefined;
  }
  return {
    rel: EXTERNAL_REL_DEFAULT,
    target: EXTERNAL_TARGET_DEFAULT
  };
};
var LinkButton = function LinkButton(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'primary' : _ref3$variant,
    _ref3$loading = _ref3.loading,
    loading = _ref3$loading === void 0 ? false : _ref3$loading,
    text = _ref3.text,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var handleClick = function handleClick(event) {
    if (!loading && props.onClick) {
      props.onClick(event);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledLink, _extends({}, secureExternalLink(props.href), props, {
    loading: loading,
    onClick: handleClick,
    variant: variant
  }), text || children);
};
LinkButton.propTypes = {
  text: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  href: _propTypes["default"].string.isRequired,
  target: _propTypes["default"].oneOf(['_blank', '_self', '_parent', '_top']),
  rel: _propTypes["default"].string
};
var _default = exports["default"] = LinkButton;